"use strict";
exports.__esModule = true;
exports.wallets$ = exports.switchChainModal$ = exports.connectWallet$ = exports.disconnectWallet$ = exports.reset$ = void 0;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var actions_1 = require("./store/actions");
var index_1 = require("./store/index");
exports.reset$ = new rxjs_1.Subject();
exports.disconnectWallet$ = new rxjs_1.Subject();
exports.connectWallet$ = new rxjs_1.BehaviorSubject({ inProgress: false, actionRequired: '' });
exports.switchChainModal$ = new rxjs_1.BehaviorSubject(null);
exports.wallets$ = index_1.state.select('wallets').pipe((0, operators_1.shareReplay)(1));
// reset logic
exports.reset$.pipe((0, operators_1.withLatestFrom)(exports.wallets$), (0, operators_1.pluck)('1')).subscribe(function (wallets) {
    // disconnect all wallets
    wallets.forEach(function (_a) {
        var label = _a.label;
        exports.disconnectWallet$.next(label);
    });
    (0, actions_1.resetStore)();
});
